import { useState, useEffect } from 'react';
import { signInWithCustomToken, signOut as firebaseSignOut, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../config/firebase';
import { getToken, getUser, getClientDomain, getFirebaseToken} from '../utils/Common';

export const useFirebaseAuth = () => {
    const [firebaseUser, setFirebaseUser] = useState(null);
    const [isFirebaseAuthenticated, setIsFirebaseAuthenticated] = useState(false);

useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
        setFirebaseUser(user);
        setIsFirebaseAuthenticated(!!user);
        
        const currentUser = getUser();
        
        if (user && currentUser) {
            const firebaseUID = user.uid;
            const expectedUID = currentUser.IdCliente.toString();
            
            if (firebaseUID !== expectedUID) {
                await firebaseSignOut(auth);
            }
        }
    });

    return unsubscribe;
}, []);

const authenticateWithFirebase = async () => {
    try {
        const userToken = getToken();
        const appUser = getUser();
        
        if (!userToken || !appUser) {
            return false;
        }

        const currentFirebaseUser = auth.currentUser;
        if (currentFirebaseUser) {
            const expectedUID = appUser.IdCliente.toString();
            if (currentFirebaseUser.uid !== expectedUID) {
                await firebaseSignOut(auth);
            }
        }

        const firebaseToken = getFirebaseToken();
        if (firebaseToken) {
            try {
                await signInWithCustomToken(auth, firebaseToken);
                return true;
            } catch (error) {
                console.error(error);
                return false;
            }
        }
    } catch (error) {
        console.error(error);
        return false;
    }
};


    const signOutFirebase = async () => {
        try {
            await firebaseSignOut(auth);
        } catch (error) {
            console.error(error);
        }
    };

    return {
        firebaseUser,
        isFirebaseAuthenticated,
        authenticateWithFirebase,
        signOutFirebase
    };
};